<i2a-resource-nodata
  *ngIf="resourceProfile && (configuration.accesses && resourceProfile.delegates.length == 0 || !configuration.accesses) && ( configuration.rulesComputedDelegates && resourceProfile.rulesComputedDelegates.length == 0 || !configuration.rulesComputedDelegates)">
</i2a-resource-nodata>